import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getDealId = createSelector(
  (state: Store) => state.dealManagement.commonDeal.dealId,
  (dealId) => dealId,
);

export const getDisplayCampaignId = createSelector(
  (state: Store) => state.dealManagement.commonDeal.userVisibleId,
  (state: Store) => state.dealManagement.commonDeal.dealId,
  (userVisibleId, dealId) => userVisibleId || dealId,
);
